import * as React from "react";
import { Link, useNavigate } from "react-router-dom";

import styles from "./styles.module.scss";
import { adminLinks, staffLinks } from "./links";
import { FaCaretDown } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import { AuthContext } from "../../context";
import { hasPermission } from "./util";
import { LogOut } from "lucide-react";

const AdminLink = ({ name, page, roles = "Admin" }: any) => {
  const [newItems, setNewItems] = React.useState({} as any);
  const navigate = useNavigate();

  const linkRenderer = (page: any) => {
    return adminLinks;
  };

  const toggleHandler = (id: any) => {
    setNewItems((prevState: any) => ({ ...prevState, [id]: !prevState[id] }));
  };

  console.log("roles=>", roles);

  const { logout } = React.useContext(AuthContext);

  const renderLinks = (links: any) => {
    return links.map((item: any, i: any) => {
      if (!hasPermission(item?.allowed, roles)) return null;

      if (item.children) {
        return (
          <div key={i} className={styles.childContainer}>
            <li
              className={name === item?.name ? styles.active : undefined}
              onClick={() => toggleHandler(i)}
            >
              <Link to={item.route}>
                <item.Icon />
                {item.name}&nbsp;&nbsp;
                <FaCaretDown />
              </Link>
            </li>

            {newItems[i] && (
              <div className={styles.child}>
                <ul>
                  {item.children.map((child: any, x: any) => (
                    <li key={x}>
                      <Link to={child.route}>
                        <child.Icon />
                        {child.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      }

      return (
        <li key={i} className={name === item?.name ? styles.active : undefined}>
          <Link to={item.route}>
            <item.Icon />
            {item.name}
          </Link>
        </li>
      );
    });
  };

  return (
    <div className={styles.links}>
      {/* <style>{`
        @media (max-width: 768px) {
          .sidebar {
            transform: translateX(${isOpen ? "0" : "-100%"});
          }
          .overlay {
            display: ${isOpen ? "block" : "none"};
          }
        }
      `}</style> */}
      <ul>
        {renderLinks(linkRenderer(page))}
        <li>
          <span onClick={() => logout("manual")}>
            <LogOut />
            Logout
          </span>
        </li>
      </ul>
    </div>
  );
};

export default AdminLink;
